import _toConsumableArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
var __jsx = React.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import Link from 'next/link';
import styled from 'styled-components';
import { NextSeo } from 'next-seo';
import * as ds from '@bob/design-system';
import * as url from '@bob/url';
import * as utils from '@bob/utils';
import { SITE_NAME, SITE_URL } from '../../../constants';
import { SortType } from '../../../hooks/useSearchEngine/sort';
import { useSearchEngine } from '../../../hooks/useSearchEngine';
import * as listingLayout from '../../../components/layout/ListingLayout';
import { Filters, Pagination, ResultList, Search } from '../../../components/search';
import { Sort } from '../../../components/Sort';
var DEFAULT_PAGE_SIZE = 9;

function BrandListComponent(_ref) {
  var brands = _ref.brands,
      className = _ref.className,
      index = _ref.index,
      relatedArticles = _ref.relatedArticles;
  var pageUrl = url.brands();
  var engine = useSearchEngine(brands, {
    index: index,
    identifier: function identifier(brand) {
      return brand.slug;
    },
    fullText: function fullText(query, brand) {
      var _utils$text$slugify, _utils$text$slugify2, _brand$creation$regio, _utils$text$slugify3, _brand$creation$city;

      var normalizedQuery = utils.text.slugify(query);
      return utils.text.slugify(brand.name).includes(normalizedQuery) || utils.text.slugify(brand.descriptionShort).includes(normalizedQuery) || ((_utils$text$slugify = utils.text.slugify(brand.creation.country)) === null || _utils$text$slugify === void 0 ? void 0 : _utils$text$slugify.includes(normalizedQuery)) || ((_utils$text$slugify2 = utils.text.slugify((_brand$creation$regio = brand.creation.region) !== null && _brand$creation$regio !== void 0 ? _brand$creation$regio : '')) === null || _utils$text$slugify2 === void 0 ? void 0 : _utils$text$slugify2.includes(normalizedQuery)) || ((_utils$text$slugify3 = utils.text.slugify((_brand$creation$city = brand.creation.city) !== null && _brand$creation$city !== void 0 ? _brand$creation$city : '')) === null || _utils$text$slugify3 === void 0 ? void 0 : _utils$text$slugify3.includes(normalizedQuery)) || brand.categories.some(function (category) {
        return category.name.includes(normalizedQuery);
      }) || brand.tags.some(function (tag) {
        return utils.text.slugify(tag.name).includes(normalizedQuery);
      });
    },
    defaultQuery: {
      filters: {},
      text: '',
      sortType: SortType.AtoZ
    },
    sorts: [{
      type: SortType.AtoZ,
      name: 'Nom (A à Z)',
      getTitle: function getTitle(brand) {
        return brand.name;
      }
    }, {
      type: SortType.ZtoA,
      name: 'Nom (Z à A)',
      getTitle: function getTitle(brand) {
        return brand.name;
      }
    }],
    defaultPage: 1,
    defaultSize: DEFAULT_PAGE_SIZE
  });
  return __jsx(React.Fragment, null, __jsx(NextSeo, {
    title: "".concat(SITE_NAME, " | Les marques"),
    description: "D\xE9couvrez toutes les marques bien pour la plan\xE8te et les humains",
    canonical: SITE_URL + pageUrl.path,
    openGraph: {
      title: "".concat(SITE_NAME, " | Les marques"),
      description: 'Découvrez toutes les marques bien pour la planète et les humains',
      url: SITE_URL + pageUrl.path,
      images: [{
        alt: 'Bien ou Bien, le magasin où acheter des biens tout simplement bien',
        url: SITE_URL + '/assets/bob_og_image.png'
      }]
    },
    robotsProps: {
      maxImagePreview: 'large'
    }
  }), __jsx(ds.Container, {
    className: className
  }, __jsx(ds.BreadCrumbs, {
    crumbs: pageUrl.crumbs
  }), __jsx(listingLayout.Heading, {
    color: ds.color.LIGHT_GREEN,
    description: "Cr\xE9ateurs en solo, petite \xE9quipe pleine de r\xEAves, producteurs, distributeurs\u2026 Toutes ces marques ont une chose en commun : leurs valeurs.",
    title: 'Les marques'
  }), __jsx(ds.LineGridLayout, null, relatedArticles && relatedArticles.map(function (article) {
    var _article$firstPublish;

    return __jsx(ds.ArticleCard, {
      key: article.slug,
      date: new Date((_article$firstPublish = article.firstPublishedAt) !== null && _article$firstPublish !== void 0 ? _article$firstPublish : '').toLocaleDateString('fr-FR', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      }),
      href: url.article({
        slug: article.slug,
        title: article.title
      }).path,
      image: _objectSpread(_objectSpread({}, article.image), {}, {
        nativeLazyLoad: true
      }),
      tag: article.category.name,
      title: article.title
    });
  })), __jsx(listingLayout.DesktopContainer, null, __jsx(Sort, {
    engine: engine,
    label: "marques tri\xE9es par "
  })), __jsx(listingLayout.Wrapper, null, __jsx(listingLayout.ScrollAnchor, {
    id: "top"
  }), __jsx(listingLayout.Aside, null, __jsx(Search, {
    engine: engine,
    placeholder: "Rechercher une marque"
  }), __jsx(listingLayout.Controls, null, __jsx(Filters, {
    engine: engine
  }), __jsx(listingLayout.MobileContainer, null, __jsx(Sort, {
    engine: engine,
    label: "marques tri\xE9es par "
  })))), __jsx(listingLayout.Main, null, __jsx(ResultList, {
    engine: engine,
    loading: placeholders
  }, function (_ref2) {
    var _brand$coverImage$src, _brand$coverImage;

    var brand = _ref2.item;
    return __jsx(listingLayout.Item, {
      key: brand.slug
    }, __jsx(Link, {
      href: url.brand({
        slug: brand.slug,
        name: brand.name
      }).path,
      prefetch: false
    }, __jsx("a", null, __jsx(ds.BrandCard, {
      nativeLazyLoad: true,
      coverImage: // TODO: FIXME: Some images are missing data side, should not be the case
      (_brand$coverImage$src = (_brand$coverImage = brand.coverImage) === null || _brand$coverImage === void 0 ? void 0 : _brand$coverImage.src) !== null && _brand$coverImage$src !== void 0 ? _brand$coverImage$src : '',
      criteria: [].concat(_toConsumableArray(brand.pillars.environmental), _toConsumableArray(brand.pillars.social)).map(function (criterion) {
        return {
          name: criterion.name,
          icon: utils.symbols.getCriterionSymbolName(criterion)
        };
      }),
      description: brand.descriptionShort,
      logo: brand.logo,
      name: brand.name,
      tags: brand.categories.map(function (tag) {
        return tag.name;
      })
    }))));
  }), __jsx(listingLayout.Pagination, null, __jsx(Pagination, {
    engine: engine
  }))))));
}

export var BrandList = styled(BrandListComponent).withConfig({
  displayName: "BrandList",
  componentId: "sc-1vancba-0"
})(["", "{margin-bottom:35px;margin-top:20px;}"], ds.LineGridLayout);

var placeholders = _toConsumableArray(new Array(DEFAULT_PAGE_SIZE).keys()).map(function (index) {
  return __jsx(listingLayout.Item, {
    key: "brand-skeleton-".concat(index)
  }, __jsx(ds.BrandCardSkeleton, null));
});